import { selectors } from 'state/selectors';
import { getWorkspaceToSaveWith } from './saveWorkspaceSelectors';

export const getWorkspaceToSave = getWorkspaceToSaveWith(selectors);
